import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex flex-col bg-background-50 pt-16">
      <div className="flex-1 flex flex-col lg:flex-row items-center w-full px-4 md:px-6">
        <div className="w-full lg:w-1/2 pt-10 lg:pt-0 pb-8 lg:pb-0">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-[1.1] tracking-tight">
            {t('hero.title')}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-foreground-600 leading-relaxed max-w-lg">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4 mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('hero.cta_start')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('hero.cta_examples')}
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex items-center justify-center">
          <div className="w-full max-w-[560px] h-[380px] md:h-[440px] rounded-2xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Vibrant%20overhead%20flatlay%20photography%20with%20colorful%20fashion%20sneakers%20in%20various%20styles%20and%20colors%20surrounded%20by%20autumn%20leaves%20and%20trendy%20accessories%20on%20warm%20terracotta%20textured%20surface%2C%20dramatic%20shadows%20from%20side%20window%2C%20editorial%20fashion%20style%2C%20rich%20warm%20contrast&width=1120&height=880&seq=hero-v2-01&orientation=landscape"
              alt="YOYBUY Spreadsheet products"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-5 h-8 rounded-full border-2 border-foreground-300 flex items-start justify-center p-1">
          <div className="w-1 h-1.5 rounded-full bg-foreground-400 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}